import { SyntheticEvent, useMemo, useState } from 'react';
import { useContextSelector as useCS } from 'use-context-selector';
import { AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { RolesEnum } from 'infrastructure/enums/RolesEnum';
import { accordionFAQJobSeekerData, accordionFAQRecruiterData } from 'view/pages/profile/helpers';
import * as S from './styled';

const FAQ = () => {
  const [expanded, setExpanded] = useState<string | false>('panel1');
  const { role } = useCS(GlobalConfigContext, globalConfigSelectors.userData);
  const helpCenterData = useMemo(() => {
    return role?.name === RolesEnum.JOB_SEEKER
      ? accordionFAQJobSeekerData
      : accordionFAQRecruiterData;
  }, [role]);

  const handleChange = (panel: string) => {
    return (event: SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  };

  return (
    <S.FAQWrapper>
      {helpCenterData.map((panel) => {
        const { id, ariaControls, expandedId, description, title } = panel;
        return (
          <S.CustomAccordion
            expanded={expanded === expandedId}
            onChange={handleChange(expandedId)}
            key={expandedId}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={ariaControls} id={id}>
              <S.AccordionTitle component="span">{title}</S.AccordionTitle>
            </AccordionSummary>
            <AccordionDetails>
              <S.AccordionDesc>{description}</S.AccordionDesc>
            </AccordionDetails>
          </S.CustomAccordion>
        );
      })}
    </S.FAQWrapper>
  );
};

export default FAQ;
